<template>
  <div v-bind="$attrs">
    <v-search
      :value="value"
      :items="res"
      item-text="account_name"
      item-value="id"
      :loading="loading"
      :required="required"
      :hint="hint"
      :search-input.sync="searchStr"
      placeholder="Search Accounts"
      :disabled="disabled"
      @search="search"
      @input="$emit('input', $event)"
      @select="select"
      @clear="clearResults"
      @valid-update="updateValidState"
    />
  </div>
</template>

<script>
import VSearch from '@/components/base/VSearch'

export default {
  props: {
    value: {
      type: [Number, String, Object],
    },
    selected: {
      type: Object
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  components: { VSearch },
  data() {
    return {
      loading: false,
      res: [],
      searchStr: '',
      isValid: false
    }
  },
  computed: {
    hint({ loading, searchStr }) {
      if (loading) {
        return 'loading'
      } else if (searchStr == null || searchStr == '') {
        return 'Please enter your search terms'
      } else {
        return 'No contacts found'
      }
    }
  },
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      if (this.value) {
        this.$http.account.get(this.value).then(resp => {
          this.searchStr = resp.data.account_name;
        });
      }
    },
    search(v) {
      if(v) {
        this.loading = true;
        this.$http.accounts.get({
          account_name: v
        }).then(resp => {
          this.res = resp.data.results;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    select(v) {
      this.$emit('update:selected', v);
    },
    clearResults() {
      this.res = [];
    },
    updateValidState(v) {
      this.isValid = v;
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown.is-fullwidth {
  width: 100% !important;
  .dropdown-trigger {
    width: 100%;
  }
}

.is-clickable {
  cursor: pointer;
  pointer-events: initial !important;
}
</style>
